import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore } from 'redux'
import {
  connectRouter,
  ConnectedRouter,
  routerMiddleware,
} from 'connected-react-router'
import { Provider } from 'react-redux'
import rootReducer from './reducers/rootReducer'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

const history = createBrowserHistory()

const store = createStore(
  connectRouter(history)(rootReducer), // new root reducer with router state
  composeWithDevTools(applyMiddleware(thunk, routerMiddleware(history)))
)

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept(rootReducer, () => {
      store.replaceReducer(connectRouter(history)(rootReducer))
    })
  }
}

const render = Component =>
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Component />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  )

render(App)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    render(NextApp)
  })
}
